// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__2K7mg","carouselItem":"styles_carouselItem__1lYeE","carouselCaption":"styles_carouselCaption__2neO5","carouselImage":"styles_carouselImage__175SH"};